module.exports = "/images/vendesk.png?d2b68ad1c1e1cd587557c3258ebb2575";